
import React from "react";
import { SearchInput } from "@/components/ui/search";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import { GuideSection } from "@/types/guideTypes";

interface GuideSidebarProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  filteredContent: GuideSection[];
  activeSection: string;
  onSectionChange: (sectionId: string) => void;
  setExpandedSections: React.Dispatch<React.SetStateAction<string[]>>;
}

export const GuideSidebar: React.FC<GuideSidebarProps> = ({
  searchQuery,
  onSearchChange,
  filteredContent,
  activeSection,
  onSectionChange,
  setExpandedSections
}) => {
  return (
    <div className="w-72 border-r border-gray-200 bg-gray-50 h-full flex flex-col fixed">
      <div className="p-4 border-b border-gray-200">
        <SearchInput
          placeholder="Search guide..."
          value={searchQuery}
          onChange={onSearchChange}
        />
      </div>
      <ScrollArea className="flex-1">
        <nav className="p-4">
          {filteredContent.map((section) => (
            <button
              key={section.id}
              onClick={() => {
                onSectionChange(section.id);
                setExpandedSections(prev => 
                  prev.includes(section.id) 
                    ? prev.filter(id => id !== section.id)
                    : [...prev, section.id]
                );
              }}
              className={cn(
                "w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors flex items-center gap-3",
                activeSection === section.id
                  ? "bg-primary text-primary-foreground"
                  : "text-gray-700 hover:bg-gray-100"
              )}
            >
              <section.icon className="h-5 w-5" />
              <span>{section.title}</span>
            </button>
          ))}
        </nav>
      </ScrollArea>
    </div>
  );
}
